import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Company } from './company';
import { CompanyService } from './company.service';
import { StatusFinancialService } from 'app/status/statusFinancial.service';
import { Status } from 'app/status/status';
import { UserClientService } from 'app/userClient/userClient.service';
import { NotificationService} from 'app/shared/notification/notification.service';
import { UserClient } from 'app/userClient/userClient';
import { Global } from 'app/core/global';
import { HttpParams } from '@angular/common/http';
import { MatTableDataSource, PageEvent } from '@angular/material';
import { TableService } from 'app/core/models/pager';
import { CompanyFilter } from './company.filter';

@Component({
	template: `
		<h3 class="title" i18n="@@companies">Companies</h3>

		<mat-accordion>
			<mat-expansion-panel [expanded]="isOpenSearchPanel" (opened)="openSearchPanel(true)" [hideToggle]="true">
				<mat-expansion-panel-header>
					<div *ngIf="tableService.filter" class="filter-panel-header fieldset-wrap">
						<div class="field-row">
							<div class="field-row-item" *ngIf="tableService.filter.name">
								<span class="label" i18n="@@name">Name</span>
								<span>{{tableService.filter.name}}</span>
							</div>
							<div class="field-row-item" *ngIf="tableService.filter.statusFinancial">
								<span class="label" i18n="@@statusFinancial">Financial status</span>
								<span>{{tableService.filter.statusFinancial.name}}</span>
							</div>
							<div class="field-row-item" *ngIf="tableService.filter.userClient">
								<span class="label" i18n="@@userClient">User client</span>
								<span>{{tableService.filter.userClient.firstName}}</span>
							</div>
						</div>
					</div>
					<button class="btn-icon" i18n-title="@@option-search" title="Search" type="button">
						<i class="material-icons">search</i>
					</button>
				</mat-expansion-panel-header>

				<form>
					<fieldset class="fieldset">
						<div class="field-row">
							<div class="field-row-item">
								<label class="label" for="name" i18n="@@name">Name</label>
								<input type="text" name="name" placeholder="None" i18n-placeholder="None" [(ngModel)]="filter.name">
							</div>
						</div>
						<div class="field-row">
							<div class="field-row-item">
								<label class="label" for="statusFinancial" i18n="@@statusFinancial">Financial status</label>
								<mat-select placeholder="None" i18n-placeholder="None" [(value)]="filter.statusFinancial" [compareWith]="compareFn" disableRipple>
									<mat-option i18n="@@select-none">None</mat-option>
									<mat-option *ngFor="let opt of statusFinancials" [value]="opt">{{opt.name}}</mat-option>
								</mat-select>
							</div>
						</div>
						<div class="field-row">
							<div class="field-row-item">
								<label class="label" for="userClient" i18n="@@userClient">Client User</label>
								<mat-select placeholder="None" i18n-placeholder="None" [(value)]="filter.userClient" [compareWith]="compareFn" disableRipple>
									<mat-option i18n="@@select-none">None</mat-option>
									<mat-option *ngFor="let opt of userClients" [value]="opt">{{opt.firstName}} {{opt.lastName}}</mat-option>
								</mat-select>
							</div>
						</div>
					</fieldset>
					<div class="options">
						<button class="btn-text gray" type="button" (click)="reset()">
							<span i18n="@@option-reset">Reset</span>
						</button>
						<button class="btn-text blue" type="button" (click)="search()">
							<span i18n="@@option-search">Search</span>
						</button>
					</div>
				</form>
			</mat-expansion-panel>
		</mat-accordion>

		<div class="tool-bar-wrap both-side">
			<div class="right row">
				<button class="btn-icon" i18n-title="@@option-create" title="Create" type="button" (click)="create()" *hasPermission="['Companies.create']">
					<i class="material-icons">add</i>
				</button>
				<ng-template [hasPermission]="['Companies.delete']">
					<button class="btn-icon" i18n-title="@@option-delete" title="Delete" type="button" (click)="confirmDelete = false" *ngIf="tableService.selection.hasValue()">
						<i class="material-icons">delete</i>
					</button>
				</ng-template>
			</div>
		</div>

		<div class="mat-elevation-z8e" *ngIf="dataSource">
			<table mat-table [dataSource]="dataSource" matSort (matSortChange)="tableService.sortData($event); list();">
				<ng-container matColumnDef="select">
					<th mat-header-cell *matHeaderCellDef>
						<mat-checkbox (change)="tableService.masterToggle(dataSource.data)"
							[checked]="tableService.selection.hasValue() && tableService.isAllSelected(dataSource.data.length)"
							[indeterminate]="tableService.selection.hasValue() && !tableService.isAllSelected(dataSource.data.length)"
							*hasPermission="['Companies.delete']">
						</mat-checkbox>
					</th>
					<td mat-cell *matCellDef="let row">
						<mat-checkbox (click)="$event.stopPropagation()"
							(change)="tableService.selection.toggle(row)"
							[checked]="tableService.selection.isSelected(row)"
							*hasPermission="['Companies.delete']">
						</mat-checkbox>
					</td>
				</ng-container>

				<ng-container matColumnDef="name">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@name">Name</th>
					<td mat-cell *matCellDef="let element">{{element.name}}</td>
				</ng-container>

				<ng-container matColumnDef="statusFinancial.name">
					<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@status">Status</th>
					<td mat-cell *matCellDef="let element" translate>{{element.statusFinancial?.name}}</td>
				</ng-container>

				<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
				<tr mat-row *matRowDef="let row; columns: displayedColumns;"
					(contextmenu)="tableService.selection.clear(); tableService.selection.select(row)" [contextMenu]="basicMenu" [contextMenuSubject]="row"
					(click)="read(row)">
				</tr>
			</table>

			<mat-paginator showFirstLastButtons
				[length]="tableService.pager.totalEntities"
				[pageIndex]="tableService.pager.pageIndex"
                [pageSize]="tableService.pager.pageSize"
				[pageSizeOptions]="[20, 50, 100]"
				(page)="list($event)">
			</mat-paginator>
		</div>

		<context-menu #basicMenu>
			<ng-template [hasPermission]="['CompanyContracts.findAll']">
				<ng-template contextMenuItem (execute)="getCompanyContracts($event.item)">
					<div class="item">
						<span i18n="@@companyContracts">Company Contracts</span>
					</div>
				</ng-template>
			</ng-template>

			<ng-template [hasPermission]="['Stores.findAll']">
				<ng-template contextMenuItem (execute)="getStores($event.item)">
					<div class="item">
						<span i18n="@@stores">Branchs</span>
					</div>
				</ng-template>
			</ng-template>

			<ng-template [hasPermission]="['Companies.update']">
				<ng-template contextMenuItem divider="true"></ng-template>
				<ng-template contextMenuItem (execute)="update($event.item)">
					<div class="item">
						<i class="material-icons">edit</i>
						<span i18n="@@option-update">Update</span>
					</div>
				</ng-template>
			</ng-template>

			<ng-template [hasPermission]="['Companies.delete']">
				<ng-template contextMenuItem divider="true"></ng-template>
				<ng-template contextMenuItem (execute)="confirmDelete = false">
					<div class="item">
						<i class="material-icons">delete</i>
						<span i18n="@@option-delete">Delete</span>
					</div>
				</ng-template>
			</ng-template>
		</context-menu>

		<modal-ns [(closed)]="confirmDelete">
			<ng-template modalContentDirective>
				<div class="dialog-content">
					<div class="dialog-title" i18n="@@confirm">Confirmation</div>
					<div class="dialog-message" i18n="@@confirm-deletes">Are you sure you want to delete the selected items?</div>
					<div class="options">
						<button class="btn-text red" type="button" (click)="confirmDelete = true">
							<span i18n="@@option-no">No</span>
						</button>
						<button class="btn-text green" type="button" (click)="deletes(); confirmDelete = true">
							<span i18n="@@option-yes">Yes</span>
						</button>
					</div>
				</div>
			</ng-template>
		</modal-ns>
	`,
})
export class CompanyListComponent implements OnInit {
	dataSource: MatTableDataSource<Company>;
	displayedColumns: string[] = ['select', 'name', 'statusFinancial.name'];
	confirmDelete = true;
	statusFinancials: Status[];
	userClients: UserClient[];
	isOpenSearchPanel = false;
	filter;

	constructor(
		private router: Router,
		private activatedRoute: ActivatedRoute,
		private companyService: CompanyService,
		private statusFinancialService: StatusFinancialService,
		private userClientService: UserClientService,
		public tableService: TableService<Company>,
		private notificationService: NotificationService,
	) {}

	ngOnInit() {
		if (!this.tableService.filter) {
			this.filter = new CompanyFilter();
			this.tableService.filter = new CompanyFilter();

			let userClientId = Global.getParamFromRoot(this.activatedRoute, 'userClientId');
			if (userClientId) {
				this.userClientService.getById(userClientId).subscribe(userClient => {
					this.filter.userClient = userClient;
					this.tableService.filter.userClient = userClient;
					this.list();
				});
			} else {
				this.list();
			}
		} else {
			this.filter = new CompanyFilter(this.tableService.filter);
			this.list();
		}
	}

	list(event?: PageEvent) {
		let httpParams = new HttpParams()
			.set('collection', 'id, name, statusFinancial(id, name)')
			.set('pager.index', event ? event.pageIndex.toString() : this.tableService.pager.pageIndex.toString())
			.set('pager.size', event ? event.pageSize.toString() : this.tableService.pager.pageSize.toString());

		if (this.tableService.sort) { httpParams = httpParams.set('sort', this.tableService.sort) }

		httpParams = this.filter.getHttpParams(httpParams);

		this.companyService.getAll(httpParams).subscribe(data => {
			this.dataSource = new MatTableDataSource<Company>(data['result']);
			this.tableService.pager = data['pager'];
			this.tableService.selection.clear();
		});
	}

	getStores(item: Company) {
		this.router.navigate(['./' + item.id + '/stores'], {relativeTo: this.activatedRoute});
	}

	getCompanyContracts(item: Company) {
		this.router.navigate(['./' + item.id + '/companyContracts'], {relativeTo: this.activatedRoute});
	}

	read(item: Company) {
		this.router.navigate(['./' + item.id], {relativeTo: this.activatedRoute});
	}

	create() {
		this.router.navigate(['./create'], {relativeTo: this.activatedRoute});
	}

	update(item: Company) {
		this.router.navigate(['./' + item.id + '/update'], {relativeTo: this.activatedRoute});
	}

	deletes() {
		const length = this.tableService.selection.selected.length;
		this.tableService.pager.pageIndex = (this.tableService.pager.pageIndex > 0 && this.tableService.pager.totalEntitiesPerPage === length) ?
			--this.tableService.pager.pageIndex : this.tableService.pager.pageIndex;

		if (length === 1) {
			this.companyService.delete(this.tableService.selection.selected[0].id).subscribe(() => {
				this.notificationService.sucessDelete();
				this.list();
			}, err => this.notificationService.error(err));
		} else if (length > 1) {
			this.companyService.deletes(this.tableService.selection.selected).subscribe(() => {
				this.notificationService.sucessDelete();
				this.list();
			}, err => this.notificationService.error(err));
		}
	}

	reset() {
		this.filter = new CompanyFilter();
	}

	search() {
		this.isOpenSearchPanel = false;
		this.tableService.pager.pageIndex = 0;
		this.tableService.filter = new CompanyFilter(this.filter);
		this.list();
	}

	openSearchPanel(value: boolean) {
		this.isOpenSearchPanel = value;
		this.filter = new CompanyFilter(this.tableService.filter);

		if (!this.userClients) {
			this.userClientService.getAll(
				new HttpParams().set('sort', 'firstName').set('collection', 'id, firstName, lastName')
			).subscribe(data => {
				this.userClients = data['result'];
			});
		}

		if (!this.statusFinancials) {
			this.statusFinancialService.getAll(
				new HttpParams().set('sort', 'name').set('collection', 'id, name')
			).subscribe(data => {
				this.statusFinancials = data['result'];
			});
		}
	}

	compareFn(c1: any, c2: any): boolean {
		return c1 && c2 ? c1.id === c2.id : c1 === c2;
	}
}
